//计算逐级审批流程条件
export function getCondtion(list, maxLevel, currentCondtion, stopName) {
	var condtion = 0.0;
	var isOver = false;
	if(list == null){
		return;
	}
	list.forEach(function(item, index) {
		if (isOver) {
			return;
		}
		if (item.Items == null) {
			condtion += 0.1;
		} else {
			item.Items.forEach(childItem => {
				if (stopName != null && stopName.length > 0) {
					//部门多个item情况指定到谁结束
					if (childItem.JobLevel > maxLevel || childItem.EmpName == stopName) {
						isOver = true;
						return;
					}
				} else {
					if (childItem.JobLevel > maxLevel) {
						isOver = true;
						return;
					}
				}
				if (childItem.JobLevel == maxLevel) {
					condtion += 0.1;
					isOver = true;
					return;
				}
			});
			if (!isOver) {
				condtion += 0.1;
			}

		}
	});
	return (condtion + currentCondtion).toString();
}
export function getRelationList(list, maxLevel, stopName) {
	var emps = [];
	var isOver = false;
	// 是否有区域董事
	var qy = false;
	// 是否有大区董事
	var dq = false;
	list.forEach(function(item, index) {
			if (isOver) {
				return;
			}
			if (item.Items != null) {
				item.Items.forEach(childItem => {
					
					if(childItem.JobLevel>3){
						if(stopName == '住宅部'){
							if (childItem.JobLevel > maxLevel) {
								isOver = true;
								if(!qy&&!dq){
									emps.push(["SC24000029", "钟志斌"]);
								}
								return;
							} else {
								if(childItem.PositionName.indexOf('战区董事')>-1){
									qy = true;
								}else if(childItem.PositionName.indexOf('高级董事总经理')>-1){
									dq = true;
								}
								emps.push([childItem.EmpNo, childItem.EmpName])
							}
							
						}
						else if (stopName != null && stopName.length > 0) {
							//部门多个item情况指定到谁结束
							if (childItem.JobLevel > maxLevel || childItem.EmpName == stopName) {
								isOver = true;
								return;
							} else {
								emps.push([childItem.EmpNo, childItem.EmpName])
							}
						} else {
							if (childItem.JobLevel > maxLevel) {
								isOver = true;
								return;
							} else {
								
								emps.push([childItem.EmpNo, childItem.EmpName])
							}
						}
						if(childItem.PositionName.indexOf(stopName)>-1){
							emps = [[childItem.EmpNo, childItem.EmpName]]
							isOver = true;
							return;
						}
					}
				});
			}
		
	});
	console.log('empsemps',emps);
	return emps;
}
export function findEmpByPositionName(list, findName, level) {
	
	
	var emps = [];
	var isOver = false;
	list.forEach(function(item, index) {
		if (isOver) {
			return;
		}
		// debugger
		if (item.Items != null) {
			item.Items.forEach(childItem => {
				if (level != null && level.length > 0) {
					if (childItem.PositionName.indexOf(findName) > -1 && childItem.JobLevel == level) {
						emps.push([childItem.EmpNo, childItem.EmpName])
						isOver = true;
						return;
					}
				}
				if(findName == '高级董事总经理' && (item.DeptName.indexOf('北区')>-1 || item.DeptName.indexOf('南区')>-1)){
					emps.push([childItem.EmpNo, childItem.EmpName])
					isOver = true;
					return;
				}
				if (childItem.PositionName.indexOf(findName) > -1 && childItem.JobLevel < 10) {
					emps.push([childItem.EmpNo, childItem.EmpName])
					isOver = true;
					return;
				}
			});
		}
	});
	return emps;
}
export function findEmpByLevel(list, level) {
	var emps = [];
	var isOver = false;
	list.forEach(function(item, index) {
		if (isOver) {
			return;
		}
		if (item.Items != null) {
			item.Items.forEach(childItem => {
				if (childItem.JobLevel >= level) {
					emps.push([childItem.EmpNo, childItem.EmpName])
					isOver = true;
					return;
				}
			});
		}
	});
	return emps;
}
//查找上级和层级是否对应
export function getSuperiorIsMatchDepth(list, level, depth) {
	var isMatch = false;
	var currentDepth = 0;
	if(list==null){
		return isMatch;
	}
	for (var i = 0; i < list.length; i++) {
		if (isMatch) {
			break;
		}
		var item = list[i];
		if (item.Items == null) {
			continue;
		}
		currentDepth++;
		for (var j = 0; j < item.Items.length; j++) {
			var childItem = item.Items[j];
			if (childItem.JobLevel > level && depth == currentDepth) {
				isMatch = true;
				break;
			}
		}
	}
	return isMatch

}

//计算指定部门登记
export function getCondtionByLevel(list, maxLevel, currentCondtion) {
	var condtion = 0.0;
	var isOver = false;
	list.forEach(function(item, index) {
		if (isOver) {
			return;
		}
		if (item.Items != null) {
			item.Items.forEach(childItem => {
				if (childItem.JobLevel > maxLevel) {
					isOver = true;
					return;
				}
				condtion += 0.1;
			})
		}

	});
	return (condtion + currentCondtion).toString();
}

import {
	getDepartmentRelationByName,
	getDepartmentRelationById,
	getDepartmentInfo
} from '@/api/department'
export async function getDepartmentRelation(deptId, findName, isBussiness) {
	var isOver = false;
	var emps = [];
	if (isBussiness == undefined) {
		isBussiness = false;
	}
	await getDepartmentInfo(deptId).then(async res => {
		await getDepartmentRelationByName(res.Body.FullName, isBussiness).then(async response => {
			if (response.Body != null && response.Body.length > 0) {
				emps = findEmpByPositionName(response.Body[0].Nodes, findName);
			}
		});
	});
	return emps;

}
export async function getDepartmentRelationList(deptId,maxLevel, findName, isBussiness) {
	var isOver = false;
	var emps = [];
	if (isBussiness == undefined) {
		isBussiness = false;
	}
	await getDepartmentInfo(deptId).then(async res => {
		if(res.Body.FullName.indexOf("非营业部")>-1){
			isBussiness = false;
		}else{
			isBussiness = true;
		}
		await getDepartmentRelationByName(res.Body.FullName, isBussiness).then(async response => {
			if (response.Body != null && response.Body.length > 0) {
				for(var i = 0; i < response.Body.length ; i++){
					emps=await getRelationList(response.Body[i].Nodes,maxLevel,findName);
					if(emps != null && emps.length>0){
						break;
					}
				}
				
			}
		});
	});
	return emps;

}



